import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class AboutV4 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__about-us-area pt-120--- pb-90 mt--30 go-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img
                  src={publicUrl + "assets/img/others/about-new.webp"}
                  alt="About Us Image"
                />
                <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
                  {/* <div className="ltn__video-img ltn__animation-pulse1">
							<img src={publicUrl+"assets/img/others/8.png"} alt="video popup bg image" />
							<a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/X7R-q9rsrtU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
							<i className="fa fa-play" />
							</a>
						</div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    About Us
                  </h6>
                  <h1 className="section-title">
                    The Leading Solar Battery Solutions Marketplace
                    <span>.</span>
                  </h1>
                  <p>
                    Atom Power (PRIVATE) Limited is driving Pakistan's energy
                    independence through the local assembly and manufacturing of
                    advanced lithium-ion batteries. Based in Karachi, we are
                    establishing a state-of-the-art facility, scheduled for
                    launch in 2025, utilizing locally sourced materials. Our
                    commitment is to provide high-quality, reliable energy
                    storage solutions that empower homes and industries.
                  </p>

                  <p>
                    Aiming to serve both local and international markets, Atom
                    Power is poised to become a key player in the global energy
                    storage sector. As a subsidiary of Wavetec, a tech industry
                    pioneer with over 30 years of experience, we combine
                    innovation with proven reliability to fuel growth and
                    sustainability worldwide.
                  </p>

                  {/* <p>
                    As a subsidiary of Wavetec, a tech industry pioneer with
                    over 30 years of experience, we combine innovation with
                    reliability to drive growth and sustainability worldwide.
                  </p> */}
                </div>
                {/* <ul className="ltn__list-item-half clearfix">
                  <li>
                    <i className="flaticon-home-2" />
                    Smart Home Design
                  </li>
                  <li>
                    <i className="flaticon-mountain" />
                    Beautiful Scene Around
                  </li>
                  <li>
                    <i className="flaticon-heart" />
                    Exceptional Lifestyle
                  </li>
                  <li>
                    <i className="flaticon-secure" />
                    Complete 24/7 Security
                  </li>
                </ul>
                <div className="ltn__callout bg-overlay-theme-05  mt-30">
                  <p>
                    "Enimad minim veniam quis nostrud exercitation <br />
                    llamco laboris. Lorem ipsum dolor sit amet"{" "}
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link to="/service" className="theme-btn-1 btn btn-effect-1">
                    OUR SERVICES
                  </Link>
                </div> */}
              </div>
            </div>
          </div>

          {/* <div className="row mt-5">
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    Empowering Users with Seamless Access
                  </h6>
                  <h1 className="section-title">
                    App and Web Portal for End Users
                    <span>.</span>
                  </h1>
                  <p>
                    With ATOM Power, take control of your energy like never
                    before. Our intuitive power flow monitoring system provides
                    real-time insights into your energy usage, helping you
                    optimize performance and reduce costs. Say goodbye to high
                    energy bills with our advanced Self-Powered Mode, designed
                    to prioritize stored solar energy for your home or business.
                    Easily track power generation and consumption through our
                    user-friendly mobile app, giving you complete transparency
                    at your fingertips. Additionally, ATOM Power offers
                    comprehensive and detailed data analytics to assist in
                    identifying and resolving system faults, ensuring reliable
                    and efficient energy storage for your needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img
                  src={publicUrl + "assets/img/others/mobile-app.png"}
                  alt="About Us Image"
                />
                <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3"></div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default AboutV4;
